import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

const currentUrl = window.location.origin;

let redirectUri = currentUrl;



export const authConfig: AuthConfig = {
  issuer: environment.ssoIssuer,
  redirectUri: redirectUri,
  clientId: environment.ssoClientId,
  responseType: "code",
  strictDiscoveryDocumentValidation: false,
  scope: environment.ssoScopes,
  showDebugInformation: true,
};
